import { Routes, PATHS } from '@components/paths';

export const getRoute = (name: Routes): string => {
    return PATHS[name]?.route;
};

export const getRouteName = (name: Routes): string => {
    return PATHS[name]?.title;
};
